<template>

	<v-container ref="scrollPane"  class="ai-cardPaneScrollTweak" fluid>
		<v-container fluid style="max-width: 1000px; mmax-height:500px;">
		
			<div class="display-1 font-weight-bold grey--text text--darken-3 pt-12">Export data</div>
			<div class="subtitle font-weight-bold grey--text text--darken-3 pt-3 mb-6">{{agile.loggedInUser.currentProject.prettyName}}</div>
			
			<v-text-field
				label="Local export folder target"
				v-model="folderPath"
				outlined
				dense
			></v-text-field>

			<v-btn @click="startExport">Export to folder</v-btn>

		</v-container>
	</v-container>
	

</template>

<script>


// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

import agile from '@/shift/agile';
import fb from '@/shift/fb';
import agileElectron from '@/shift/agileElectron';


// ----------------------------------
//	VUE: Start default
// ----------------------------------

export default
{
	name: 'DevExport',
	

	// ----------------------------------
	//	VUE: Data and computed
	// ----------------------------------

	data: () =>
	({
		agile: agile,
		folderPath: '',
		allowUserSync: true,
	}),

	computed:
	{
       appBarHeight()
		{
			return agile.appBarHeight();
		},

		routeKey()
		{
			return this.$route.params.key;
		},

    },

	watch:
	{
		folderPath()
		{
			this.setUserSettings();
			agileElectron.folderPath = this.folderPath;
		}
	},


	// ----------------------------------------------------
    //
    //  VUE hooks: Create
    //
	// ----------------------------------------------------
	
	created()
	{
		this.boundOnResize = this.onResize.bind(this)
		window.addEventListener('resize', this.boundOnResize);
		this.getUserSettings();

		agileElectron.folderPath = this.folderPath;
		agileElectron.key = this.routeKey;
		agileElectron.$alert = this.$root.$alert;
	},

	mounted()
	{
		this.onResize();
	},


	// --------------------------------------------------------------------
    //
    //	VUE: Methods
    //
	// --------------------------------------------------------------------

	methods:
	{
		startExport()
		{
			agileElectron.startExport()
			//agileElectron.saveFile();
		},


		getUserSettings()
		{
			// Get folder open/closed state for user since last session
			if (agile.loggedInUser.uid)
			{
				fb.db.collection("users").doc(agile.loggedInUser.uid).collection("saved-states").doc(this.routeKey).get()
				.then((doc) =>
				{
					if (doc.exists)
					{
						const docData = doc.data();

						if (docData.devExportFolder) this.folderPath = docData.devExportFolder;
					}
					else
					{
						console.log("getUserSettings(): No such document!");
					}
				})
				.catch((error) =>
				{
					console.log('Error getting user settings document:', error.message);
				});

			}
		},


		setUserSettings()
		{
			// We want to save which documents we have open in the tab menu, and the active tab
			if (agile.loggedInUser.uid && this.allowUserSync)
			{
				
				// We don't want to spam the firestore database, wait atleast 1 second before we update, and block other requests to sync meanwhile
				this.allowUserSync = false;
				
				setTimeout(() =>
				{
					this.allowUserSync = true;

					
					const saveStateData =
					{
						devExportFolder: this.folderPath,
					};
					
					// Ok, do the sync command
					fb.db.collection("users").doc(agile.loggedInUser.uid).collection("saved-states").doc(this.routeKey).set(saveStateData, { merge: true })
					.then(() =>
					{
						//console.log("Updated user states");
					})
					.catch((error) =>
					{
						console.log('Error updating user setting:', error.message);
					});

				}, 1000);

				
			}
		},



		onResize()
		{
			this.$refs.scrollPane.style.height = (window.innerHeight-this.appBarHeight)+'px';
		},

	},

	beforeDestroy()
	{
		window.removeEventListener('resize', this.boundOnResize);
	},
	
}
</script>